<template>
	<div style="width:100%;height:100%;" ref="pie">

	</div>
</template>

<script>
	import echarts from 'echarts'

	function setOption(data) {
		var option = {
			backgroundColor: '#fff',
			title: {
				show:true,
        z:6,
				text:data.title.allNum,
				subtext: data.title.name,
				x:'28%',
        textAlign:'center',
				padding:5,
				y: '30%',
				textStyle:{
					fontSize:16,
					color:'#018de0'
				},
        subtextStyle:{
          fontSize:14,
          color:'#000'
        }
			},
			grid:{
				left: '56%', //grid 组件离容器左侧的距离。
				right: '6%', //grid 组件离容器右侧的距离。
				top:'0%',
				bottom: '4%', //grid 组件离容器下侧的距离。
				containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
			},
			tooltip: {
				show: true,
				trigger: 'item',
				formatter: "{b}: {c} ({d}%)"
			},
			legend: {
				type: 'scroll',
				// orient: 'horizontal',
				orient: 'vertical',
				left: '54%',
				top: 'middle',
				itemGap: 4,
				itemWidth: 5,
				itemHeight: 10,
				padding: 10,
				// bottom: '0%',
				data: data.legend
			},
			series: [{
	            type:'pie',
	            selectedMode: 'false',
	            radius: ['55%', '77%'],
							center : ['30%','40%'],
	            // color:['#32AFD8'],
	            // label: {
	            //   normal: {
							// 		position: 'center',
							// 		formatter: '{c}',
							// 		textStyle: {
							// 			color: '#30B1D3',
							// 			fontSize: 18,
							// 			fontWeight:'bold'
							// 		},
	            //   }
	            // },
							itemStyle:{
								normal:{
									color:'rgba(0,0,0,0.05)'
								}
							},
							labelLine:{
								normal:{
									show:false
								}
							},
							silent: true,
	            data:[
	               100 // {value:data.total}
	            ]
	        },{
						name:data.title,
						type: 'pie',
						selectedMode: false,
						radius: ['52%', '68%'],
						center : ['30%','40%'],
						color: ['#ec604d', '#f6a852', '#7fdff0', '#95e995', '#C5C5C5','#F8AE71','#BA9DDD'],
						label: {
							normal: {
								position: 'inner',
								// formatter: '{d}%',
								formatter: function(params){
									return params.value;
								},
								textStyle: {
									color: '#57617B',
									fontSize: 12
								}
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: data.data
			}]
		};
		return option
	}
	export default {
		name: 'TitlePie',
		props: ['args'],
		methods: {
			initChart() {
				window.addEventListener('resize', function() {
					this.myChart.resize()
				}.bind(this))
			},
			resize: function() {
				this.myChart.resize()
			},
			reDrawChart: function(args) {
				this.myChart.setOption(setOption(args), false);
			},

		},
		mounted: function(el) {
			var container = this.$el
			this.initChart();
			this.myChart = echarts.init(container);
			let that =this;
			this.myChart.on('click',function(param){
				if(param.data.name =="资源在保，服务中"||param.data.name =="资源不在保，服务未过期"||param.data.name =="资源不在保，服务过期"){
					that.$emit('getserverStatus',param.data.name);
				}
				if(param.data.name =="路由"||param.data.name =="安全"||param.data.name =="无线"||param.data.name =="交换"){
					that.$emit('getNetResource',param.data.name);
				}
				
			});
		},
		watch: {
			updateFlag: function(val) {
				setTimeout(() => {
					this.myChart.resize()
				}, 150);
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/echarts/pieTitleChart.vue